import * as Sentry from '@sentry/angular';
import { appConfig as baseAppConfig } from './app-config.base';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';

Sentry.init({
  dsn: 'https://f78d70d12caa995b56cfee9d29a57d18@o4510389507850240.ingest.us.sentry.io/4510389509357568',
  tunnel: 'https://back.goodchart.co/ap/s',
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.replayCanvasIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', 'https://back.goodchart.co'],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

export const appConfig: ApplicationConfig = {
  ...baseAppConfig,
  providers: [
    ...baseAppConfig.providers,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
